module.exports = __webpack_public_path__ + "img/data_downlod_txt3.669bce4f.png";